module.exports = __webpack_public_path__ + "img/prepack-other.ad889212.png";